import { ENV_CONFIG } from 'config/environment';
import { IPage } from 'store/donatePage/types';
import { SetsData } from 'store/sets/types';

const tagsBase = () => `${ENV_CONFIG().CLOUD_STORAGE.URL}/${ENV_CONFIG().CLOUD_STORAGE.TAGS}`;

const setsBase = () => `${ENV_CONFIG().CLOUD_STORAGE.URL}/${ENV_CONFIG().CLOUD_STORAGE.SETS}`;

type PageImageSource = Pick<IPage, 'id' | 'image_filenames'>;

export const getPageImageUrl = (page: PageImageSource): string =>
  `${tagsBase()}/${page.image_filenames?.principal_logo ?? `tag_${page.id}.png`}`;

export const getRecipientPhotoUrl = (photoId: string): string =>
  `${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${photoId}.jpg`;

export const getCommunityImageUrl = (page: IPage): string =>
  `${tagsBase()}/icon/${page.image_filenames?.community_logo ?? `tag_${page.id}.png`}`;

export const getOptionalMediaUrl = (page: IPage): string => {
  const ext = page.optional_media_type === 'video' ? 'mp4' : 'png';
  return `${tagsBase()}/optional_media/${
    page.image_filenames?.optional_media ?? `tag_${page.id}.${ext}`
  }`;
};

export const getSetLogoUrl = (setsData: SetsData, urlPartner: string | undefined): string => {
  const filename = setsData.image_filenames?.header_logo;
  return filename ? `${setsBase()}/${filename}` : `${setsBase()}/${urlPartner ?? ''}/set-logo.png`;
};

export const getSetVideoUrl = (setsData: SetsData, urlPartner: string | undefined): string => {
  const filename = setsData.image_filenames?.header_video;
  return filename ? `${setsBase()}/${filename}` : `${setsBase()}/${urlPartner ?? ''}/header.mp4`;
};

export const getSectionImageUrl = (
  setsData: SetsData,
  sectionId: string,
  urlPartner: string | undefined
): string => {
  const filename = setsData.image_filenames?.[`section:${sectionId}`];
  return filename
    ? `${setsBase()}/${filename}`
    : `${setsBase()}/${urlPartner ?? ''}/section-${sectionId}-logo.png`;
};
